/** @jsxImportSource @emotion/react */
import { Partnership } from "../../service/api-response/PartnershipListSuccessResponse";
import { MemberCardType } from "../member-card-type/models/MemberCardTypesByOrganizationSuccessResponse";
import { MemberCardPool } from "../../service/api-response/MemberCardPoolsSuccessResponse";
import { FormProvider, useForm } from "react-hook-form";
import { css } from "@emotion/react";
import { SelectInput } from "../../components/forms/inputs/SelectInput";

type Props = {
  onSubmit: Function;
  isUpserting: boolean;
  partnership: Partnership | Partial<Partnership>;
  memberCardTypes: MemberCardType[];
  memberCardPools: MemberCardPool[];
};

const bodyGap = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PartnershipUpsertForm = ({
  onSubmit,
  isUpserting,
  partnership,
  memberCardTypes,
  memberCardPools,
}: Props) => {
  const isEdit = (): boolean => {
    return !!partnership;
  };

  const methods = useForm<Partnership>({
    defaultValues: {
      ...partnership,
    },
  });

  const handleSubmit = (values: Partnership) => {
    onSubmit(values);
  };
  const memberCardTypeOptions = memberCardTypes.map((x) => ({
    label: `${x.name}`,
    value: x.id,
  }));

  const memberCardPoolOptions = memberCardPools.map((x) => ({
    label: `${x.name}`,
    value: x.name,
  }));

  if (!partnership) {
    return null;
  }

  return (
    /* @ts-ignore */
    <FormProvider {...methods}>
      <form className="card">
        <div className="card-header">
          <h3 className="card-title">
            {isEdit() ? "Edit Partnership" : "New Partnership"}
          </h3>
        </div>
        <div className="card-body">
          <div className="row">
            <div css={bodyGap} className="col-12">
              <SelectInput
                name="memberCardTypeId"
                label="Member card type"
                options={memberCardTypeOptions}
                placeholder="Select a member card type"
              />
              <SelectInput
                name="pool"
                label="Pool"
                options={memberCardPoolOptions}
                placeholder="Select a member card pool"
              />
            </div>
          </div>
        </div>
        <div className="card-footer text-right">
          <button
            className="btn btn-primary"
            type="button"
            onClick={methods.handleSubmit(handleSubmit)}
            disabled={isUpserting}
          >
            {isUpserting ? <>Saving...</> : <>Save</>}
          </button>
        </div>
      </form>
    </FormProvider>
  );
};
